enum ViewTypes {
    info = "info",
    assets = "assets",
    reusableComponents = "reusableComponents",
    approvals = "approvals",
    usedInScreens = "usedInScreens"
}

export default ViewTypes;
